import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ElementActions, ElementTypes, GaContext } from '@fcom/common';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';
import { LanguageService } from '@fcom/ui-translate';
import { AgentforceChatService } from '@fcom/chat/services/agentforce-chat.service';
import { HelpButtonStatus } from '@fcom/chat/interfaces';

@Component({
  selector: 'cms-chat-deeplink',
  template: `<fcom-button (clickBtn)="openChat()" [text]="buttonText()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatDeeplinkComponent {
  private agentforceService = inject(AgentforceChatService);
  private gtmService = inject(GtmService);
  private languageService = inject(LanguageService);

  content = input<string>('');

  private readonly openChatButtonText = toSignal(this.languageService.translate('chat.openChatButton'), {
    initialValue: '',
  });

  buttonText = computed((): string => {
    return this.content() || this.openChatButtonText();
  });

  openChat(): void {
    this.agentforceService.chatButtonState$.next(HelpButtonStatus.CLICKED);
    this.trackElement('open-pre-chat-button');
  }

  private trackElement(label: string): void {
    this.gtmService.trackElement(label, GaContext.CHAT, ElementTypes.BUTTON, undefined, ElementActions.CLICK);
  }
}
